import { IPanelStyles, ITheme } from '@fluentui/react';
import { Theme } from '../../Models/Constants/Enums';

export const getPanelStyles = (
    _themeSetting: Theme,
    _theme: ITheme
): Partial<IPanelStyles> => {
    return {
        root: {
            marginTop: 48
        },
        contentInner: { paddingTop: 40 }
    };
};
